<template>
  <div class="col-xs-12 col-sm-10 default-list-contain-sty">
    <div class="order-main-title-sty">
      <h5>請於時間內匯款至以下帳戶:</h5>
    </div>
     <div class="order-contain">
      <div><b>{{ this.companyBankName }}</b><b style="color: #456361">{{ this.companyBankCode }}</b></div>
      <div style="color: #AA7A72" @click="copyCompanyAccount">{{ this.companyAccount }}</div>
      <b-button
        size="sm" variant="secondary"
        @click="copyCompanyAccount"
      >
        <b-icon icon="files" aria-hidden="true"></b-icon>
        複製帳戶
      </b-button>
     </div>
    <div v-if="hadUnactiveData">
      <div class="order-main-title-sty">
        <h5>
          儲值方案匯款確認
        </h5>
      </div>
      <hr>
      <div class="order-contain">
        <div><b>{{ planInfo.plan_name }}</b></div>
        <div>
          <span>方案儲值金額: </span>
          <span style="color: #456361"><b>{{ planInfo.cash }}</b></span>
        </div>
        <div v-if="planInfo.total_transfer_cash > 0">
          <span>已確認匯款金額: </span>
          <span style="color: #9EADAD">{{ planInfo.total_transfer_cash }}</span>
        </div>
        <div>
          <span>還需匯入金額: </span>
          <span style="color: #AA7A72"><b>{{ planInfo.needCash }}</b></span>
        </div>
        <hr>
        <div>
            <p>
              匯款完成後<br/>
              請將匯款帳戶後5碼於下方輸入 <br/>
              我們將會有專人為您確認
            </p>
          </div>
        <b-form-group
          label="此次匯款金額"
          label-for="cash"
          style="font-weight: bolder;"
        >
          <input type="number" class="form-control re-order-input-sty" id="transfer_code" name="cash" v-model="cash" placeholder="您匯入金額">
        </b-form-group>
        <b-form-group
          label="請輸入匯款帳戶後5碼"
          label-for="transfer_code"
          style="font-weight: bolder;"
        >
          <input type="number" class="form-control re-order-input-sty" id="transfer_code" name="transfer_code" v-model="transfer_code" placeholder="您的帳戶後五碼">
        </b-form-group>
        <b-form-group label="匯款日期">
          <b-form-datepicker id="transfer_date" v-model="transfer_date" class="mb-2 re-order-input-sty"></b-form-datepicker>
        </b-form-group>
      </div>
      <div class="order-footer-contain text-right">
        <b-button
            class="text-white order-info-btn-sty"
            variant="info"
            size="md"
            @click="checkTransfer">
            送出
        </b-button>
      </div>
    </div>
    <div v-else></div>
    <b-modal id="rsTransferPlanCodeSucess" ref="rstransferplancodesucess-modal">
      <template>
        <div class="row">
          <span>成功送出!</span>
          <span>匯入款項很快會為您做確認</span>
        </div>
      </template>
      <template #modal-footer>
        <b-button size="lg" variant="info" @click="closeLiff()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
    <b-modal id="rsTransferPlanCodeFail" ref="rstransferplancodefail-modal">
      <template>
        <div class="row">
          <span>{{ errorInfo.title }}</span>
          <span>{{ errorInfo.msg }}</span>
        </div>
      </template>
      <template #modal-footer>
        <b-button size="lg" variant="info" @click="closeLiff()" style="width:100px;">
          確認
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  name: 'TransferCodeConfirm',
  props: {
    userId: String,
    userType: String
  },
  data () {
    return {
      planInfo: {},
      transfer_code: null,
      transfer_date: null,
      transfer_time: null,
      cash: 0,
      hadUnactiveData: false,
      errorInfo: {
        title: '抱歉，發生未預期的錯誤',
        msg: '請稍後再嘗試或是與客服聯絡，謝謝'
      },
      companyBankName: '土地銀行',
      companyBankCode: '005',
      companyAccount: '144001022948'
    }
  },
  created () {
    this.$nextTick(() => {
      this.getUnActiveData()
    })
  },
  watch: {
    transfer_code (value) {
      var valArr = []
      var finalVal
      if (value) {
        valArr = String(value).split('')
        if (valArr.length > 5) {
          valArr.splice(5)
          finalVal = parseInt(valArr.join(''))
          console.log(finalVal)
          this.transfer_code = finalVal
        }
      }
    }
  },
  methods: {
    getUnActiveData () {
      const self = this
      const url = this.$apiDoc.customerUrl + this.userId + this.$apiDoc.apiGetUnActiveTransferPlan
      var isError = true
      this.$parent.isLoadShow = true
      this.$api.get(url).then((resp) => {
        if (resp.result) {
          if (resp.data) {
            isError = false
            self.arrangeData(resp.data)
            self.hadUnactiveData = true
          } else {
            self.errorInfo.title = '目前尚無需要匯款方案'
            self.errorInfo.msg = '確認後將關閉此視窗'
          }
        } else {
          if (resp.data) {
            self.errorInfo.title = resp.data
            self.errorInfo.msg = '確認後將關閉此視窗'
          }
        }
        self.$parent.isLoadShow = false
        if (isError) {
          self.$bvModal.show('rsTransferPlanCodeFail')
        }
      }).catch((err) => {
        self.setDebugInfo('getUnActiveData', err, false)
        self.$parent.isLoadShow = false
        self.$bvModal.show('rsTransferPlanCodeFail')
      })
    },
    arrangeData (data) {
      var needCash = 0
      var totalTransfer = 0
      if (data) {
        totalTransfer = data.total_transfer_cash ? data.total_transfer_cash : 0
        needCash = data.cash - totalTransfer
        this.planInfo = data
        this.planInfo.needCash = needCash
      }
    },
    checkTransfer () {
      var valArr = []
      var isError = true
      if (this.cash < 1) {
        this.$bvToast.toast('匯入金額必須大於0', {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
      } else {
        if (this.transfer_code) {
          valArr = String(this.transfer_code).split('')
          if (valArr.length === 5) {
            isError = false
          }
        }
        if (isError) {
          this.$bvToast.toast('請完整輸入您帳戶的後五碼，謝謝', {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        } else {
          if (this.transfer_date) {
            this.submitTransfer()
          } else {
            this.$bvToast.toast('請選擇匯款日期，謝謝', {
              title: '',
              toaster: 'b-toaster-top-center',
              variant: 'danger',
              solid: true
            })
          }
        }
      }
    },
    submitTransfer () {
      const self = this
      const transferDate = new Date(this.transfer_date).toISOString()
      var options = {
        top_up_trans_id: this.planInfo.id,
        transfer_cash: this.$toolDoc.turnToNumber(this.cash),
        transfer_code: String(this.transfer_code),
        transfer_at: transferDate
      }
      var errorMsg
      this.$parent.isLoadShow = true
      this.$api.post(this.$apiDoc.apiTransferNotify, options).then((resp) => {
        if (resp.result) {
          self.$bvModal.show('rsTransferPlanCodeSucess')
        } else {
          if (resp.data) {
            errorMsg = resp.data
          }
          self.$bvToast.toast(errorMsg, {
            title: '',
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            solid: true
          })
        }
        self.$parent.isLoadShow = false
      }).catch((errorInfo) => {
        console.warn('errorInfo', errorInfo)
        self.$parent.isLoadShow = false
        errorMsg = self.$toolDoc.convertErrorMsg(errorInfo)
        self.$bvToast.toast(errorMsg, {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          solid: true
        })
      })
    },
    setDebugInfo (type, val, ispop) {
      // const self = this
      const setLogApi = this.$apiDoc.apiSetLog
      const userId = this.$store.getters.getUserId
      var errorMsg = this.$toolDoc.defaultErrorMsg
      var option = {}
      var logMsg = '[Debug][Reception]'
      if (type) {
        logMsg += '[' + type + '][errorInfo]: '
      }
      logMsg += JSON.stringify({ message: val.message, stack: val.stack })
      option.err = logMsg
      option.line_user_id = userId
      this.$api.post(setLogApi, option).then((resp) => {
        if (resp.result) {
          if (ispop) {
            alert(errorMsg)
          }
        }
      }).catch((errorInfo) => {
        errorMsg += '[errorInfo]:' + JSON.stringify(errorInfo)
        if (ispop) {
          alert(errorMsg)
        } else {
          console.log(errorMsg)
        }
      })
    },
    closeLiff () {
      this.$liff.closeWindow()
    },
    copyCompanyAccount () {
      const self = this
      navigator.clipboard.writeText(this.companyAccount).then(() => {
        self.$bvToast.toast('成功複製帳號', {
          title: '',
          toaster: 'b-toaster-top-center',
          variant: 'success',
          solid: true
        })
      })
    }
  }
}
</script>
